import React from 'react';
import * as T from '../Typography';
import { CircleChart, CircleContent } from './style';
import colors from '../../theme/colors';

const SectionProgressCircle: React.FC<{}> = ({ percentage, sectionNumber }) => {
  return (
    <CircleChart percentage={percentage}>
      <CircleContent>
        <T.TextSmallBold color={colors.yellow.shades.shade600}>
          {sectionNumber}
        </T.TextSmallBold>
      </CircleContent>
    </CircleChart>
  );
};

export default SectionProgressCircle;
